import type { CompanySheet } from '@/types/category';

interface CompanyCardProps {
  company: CompanySheet;
  onClick: () => void;
  sectorName?: string;
}

function resolveLogoUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  return url;
}

export function CompanyCard({ company, onClick, sectorName }: CompanyCardProps) {
  const logoSrc = resolveLogoUrl(company.logo_url);
  const displayName = company.display_name || company.title;

  return (
    <button
      onClick={onClick}
      className="bg-white min-h-[260px] md:h-[305px] rounded-[16px] overflow-hidden text-left transition-colors border border-peach-1 hover:border-pif-green"
    >
      {sectorName && (
        <p className="px-4 pt-4 md:px-[19px] md:pt-[23px] text-[12px] font-medium text-pif-green uppercase tracking-[2px] leading-none">
          {sectorName}
        </p>
      )}

      <div className="h-[120px] mt-4 md:h-[149px] md:mt-[23px] flex items-center justify-center px-4 md:px-5 py-2 overflow-hidden">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={displayName}
            className="max-h-[134px] max-w-full object-contain"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
              (e.target as HTMLImageElement).nextElementSibling?.classList.remove('hidden');
            }}
          />
        ) : null}
        <div
          className={`w-full h-full bg-peach rounded-md flex items-center justify-center ${logoSrc ? 'hidden' : ''}`}
        >
          <span className="text-[32px] font-bold text-pif-green">
            {displayName.charAt(0)}
          </span>
        </div>
      </div>

      <div className="px-4 pt-4 pb-4 md:px-[19px] md:pt-6 md:pb-0">
        <p className="text-[19px] font-bold text-grey-black tracking-[0.3px] leading-tight line-clamp-2">
          {displayName}
        </p>
      </div>
    </button>
  );
}
